import { forwardRef } from 'react';

import { ModoDaImagem, SeloDaColecao } from '../selos-modelo';
import CartaoDeSelo from './CartaoDeSelo';

/** Grade da coleção, numa lista nomeada (SEL-42). As colunas seguem o `auto-fill` do design (SEL-50). */
interface ListaDeSelosProps {
  selos: SeloDaColecao[];
  temFoto: boolean;
  modo: ModoDaImagem;
  onAtualizarFoto: () => void;
}

// Focável por script: recebe o foco quando a troca de foto tira da tela o botão que o tinha (`useFocoNaTrocaDeFoto`).
const ListaDeSelos = forwardRef<HTMLUListElement, ListaDeSelosProps>(function ListaDeSelos({ selos, temFoto, modo, onAtualizarFoto }, ref) {
  return (
    <ul
      ref={ref}
      tabIndex={-1}
      aria-label="Selos conquistados"
      className="m-0 grid list-none grid-cols-[repeat(auto-fill,minmax(238px,1fr))] gap-[18px] p-0 focus:outline-none"
    >
      {selos.map(selo => (
        <li key={selo.id}>
          <CartaoDeSelo selo={selo} temFoto={temFoto} modo={modo} onAtualizarFoto={onAtualizarFoto} />
        </li>
      ))}
    </ul>
  );
});

export default ListaDeSelos;
